module.exports = __webpack_public_path__ + "img/kehu2.49f673d3.jpg";